import {createContext} from 'react';

export const AppContext = createContext({});

export const AppContextProvider = (props: any) => {
    // const [viewMode, setViewMode] = useState('product'); // product|order
    //
    const contextValue = {
    //     viewMode,
    //     setViewMode,
    };

    return (
        <AppContext.Provider value={contextValue}>
            {props.children}
        </AppContext.Provider>
    );
};

export default AppContext;
